import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, inject, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

import { environment } from '../environments/current';
import { VERSION } from '../environments/version';
import { AuthService } from './shared/services/auth.service';
import { LoggerService } from './shared/services/logger.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-bolco',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FooterComponent, HeaderComponent, RouterModule],
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private logger = inject(LoggerService);
  public paginaInicial = false;

  ngOnInit(): void {
    this.logger.info(`bolco - ${VERSION}`);
    this.logger.debug(`EnvProd:${environment.production}`);
    this.paginaInicial = this.router.url === '/';
    this.logger.debug({ 'App:Pagina:Init': this.router.url });
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        const baseUrl = this.cleanUrl(evt.url);
        this.paginaInicial = baseUrl === '/';
        this.logger.debug({ 'App:Pagina:Evt': baseUrl });
      }
    });

    this.authService.isLoggedIn.subscribe(isLoggedIn => {
      if (!['/', '/regras', '/privacy'].includes(this.router.url) && !isLoggedIn) {
        this.logger.debug('App:Router:Redirect');
        this.router.navigate(['']);
      }
    });
  }

  scroll(el: HTMLElement): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  private cleanUrl(url: string): string {
    const urlTree = this.router.parseUrl(url);
    urlTree.queryParams = {};
    urlTree.fragment = null; // optional
    return urlTree.toString();
  }
}
